import { StatusTagProps } from './listing/partials/StatusTagComponent';

export const PaymentRoutesList = {
  PAYMENT_LANDING: 'all',
  PAYMENT_DETAILS: 'detail',
  PAYOUT_DETAILS: 'payout-detail',
  PAYMENT_TRANSACTIONS: 'all-transactions',
};

interface IPaymentListStatusObj {
  [status: string]: {
    label: string;
    varient: StatusTagProps['variant'];
    tooltipText: string;
  };
}

export const PaymentListStatusObj: IPaymentListStatusObj = {
  paid: {
    label: 'Paid',
    varient: 'success',
    tooltipText: 'This payment is successful and funds have been collected.',
  },
  refunded: {
    label: 'Refunded',
    varient: 'neutral',
    tooltipText: 'A full refund has been initiated on this payment.',
  },
  partially_refunded: {
    label: 'Partial refund',
    varient: 'neutral',
    tooltipText: 'A partial refund of the original payment amount has been initiated on this payment.',
  },
  pending: {
    label: 'Paid',
    varient: 'positive',
    tooltipText: 'This payment is still pending.',
  },
  failed: {
    label: 'Failed',
    varient: 'negative',
    tooltipText: 'The attempt to collect funds from the payment method was not successful.',
  },
  cancelled: {
    label: 'Cancelled',
    varient: 'neutral',
    tooltipText: 'This payment has been cancelled.',
  },
  disputed: {
    label: 'Disputed',
    varient: 'warning',
    tooltipText: 'At least one charge on the payment method has been disputed.',
  },
  not_captured: {
    label: 'Authorised',
    varient: 'negative',
    tooltipText: 'The payment method has been authorised but funds are not yet captured.',
  },
  incomplete: {
    label: 'Incomplete',
    varient: 'negative',
    tooltipText: 'This payment has not been completed by the customer.',
  },
};

export const PaymentExportColumnsObj = {
  CreatedOnDate: 'Created On Date',
  OrderId: 'Order Id',
  PaymentOption: 'Payment Option',
  Amount: 'Amount',
  Currency: 'Currency',
  LatestUpdatedDate: 'Latest Updated Date',
  Status: 'Status',
  StatusReason: 'Status Reason',
  RefundId: 'Refund Id',
  DisputeId: 'Dispute Id',
  DisputeFee: 'Dispute Fee',
  Merchant: 'Merchant',
  MerchantId: 'Merchant Id',
  TransactionId: 'Transaction Id',
  OrderType: 'Order Type',
  Description: 'Description',
  CardNumber: 'Card Number',
  CardExpiryDate: 'Card Expiry Date',
  IssuingBank: 'Issuing Bank',
  IssuingCountry: 'Issuing Country',
  CvvCheck: 'CVV Check',
  ThreeDs: '3DS',
  CardType: 'Card Type',
  ServiceFeesTotal: 'Service Fees Total',
  ServiceFeesFixedPercentageAmount: 'Service Fees Fixed Percentage Amount',
  ServiceFeesFixedAmount: 'Service Fees Fixed Amount',
  MerchantSurchargeTotal: 'Merchant Surcharge Total',
  CustomerName: 'Customer Name',
  CustomerId: 'Customer Id',
  CustomerEmail: 'Customer Email',
  CustomerPhoneNumber: 'Customer Phone Number',
};

export const PaymentFilterStatusObj = {
  paid: {
    label: 'Paid',
    value: 'paid',
  },
  refunded: {
    label: 'Refunded',
    value: 'refunded',
  },
  partially_refunded: {
    label: 'Partially Refunded',
    value: 'partially_refunded',
  },
  pending: {
    label: 'Pending',
    value: 'pending',
  },
  failed: {
    label: 'Failed',
    value: 'failed',
  },
  cancelled: {
    label: 'Cancelled',
    value: 'cancelled',
  },
  disputed: {
    label: 'Disputed',
    value: 'disputed',
  },
  not_captured: {
    label: 'Not Captured',
    value: 'not_captured',
  },
  incomplete: {
    label: 'Incomplete',
    value: 'incomplete',
  },
};

export const TxnExportColumnsObj = {
  CreatedOnDate: 'Created On Date',
  TransactionId: 'Transaction Id',
  TransactionType: 'Transaction Type',
  Amount: 'Amount',
  Currency: 'Currency',
  Merchant: 'Merchant',
  MerchantId: 'Merchant Id',
  OrderId: 'Order Id',
  AvailableOnDate: 'Available On Date',
  PayoutId: 'Payout Id',
  TransactionTransferId: 'Transaction Transfer Id',
};

export const TxnFilterEntryTypeObj = {
  Payment: 'Payment',
  Refund: 'Refund',
  PaymentFee: 'PaymentFee',
  TransactionTransfer: 'TransactionTransfer',
  PaymentFeeReversal: 'PaymentFeeReversal',
  TransactionTransferReversal: 'TransactionTransferReversal',
  TransactionTransferFeeReversal: 'TransactionTransferFeeReversal',
  Payout: 'Payout',
  PayoutReversal: 'PayoutReversal',
  Dispute: 'Dispute',
  DisputeFee: 'DisputeFee',
  DisputeReversed: 'DisputeReversed',
  DisputeFeeReversed: 'DisputeFeeReversed',
  MarketplaceFeePayment: 'MarketplaceFeePayment',
};

export const TxnStatusObj: IPaymentListStatusObj = {
  paid: {
    label: 'Paid',
    varient: 'success',
    tooltipText: 'This payout is successful.',
  },
  canceled: {
    label: 'Cancelled',
    varient: 'neutral',
    tooltipText: 'Cancelled',
  },
  failed: {
    label: 'Failed',
    varient: 'negative',
    tooltipText: 'Failed',
  },
  pending: {
    label: 'Pending',
    varient: 'positive',
    tooltipText: 'Pending',
  },
  in_transit: {
    label: 'In Transit',
    varient: 'warning',
    tooltipText: 'In Transit',
  },
  reversed: {
    label: 'Reversed',
    varient: 'warning',
    tooltipText: 'Reversed',
  },
  suspended: {
    label: 'Suspended',
    varient: 'negative',
    tooltipText: 'Suspended',
  },
};

export default PaymentRoutesList;
